// extracted by mini-css-extract-plugin
var _1 = "RequestBoardCard-moduleRequestBoardCard__icvJM";
var _2 = "RequestBoardCard-modulelabels__FX0Eh EntityLabelList-moduleEntityLabelList__KRfqw";
var _3 = "RequestBoardCard-modulepending__X0ijj";
export { _1 as "RequestBoardCard", _2 as "labels", _3 as "pending" }
